import { render, staticRenderFns } from "./CommercialUnassignedBudgetCard.vue?vue&type=template&id=790a7f4c&scoped=true"
import script from "./CommercialUnassignedBudgetCard.vue?vue&type=script&lang=js"
export * from "./CommercialUnassignedBudgetCard.vue?vue&type=script&lang=js"
import style0 from "./CommercialUnassignedBudgetCard.vue?vue&type=style&index=0&id=790a7f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a7f4c",
  null
  
)

export default component.exports